// src/components/translation-modules/ModuleSelector.js
import React from "react";
import {
  FaLanguage,
  FaUtensils,
  FaImage,
  FaBoxOpen,
  FaList,
  FaFileInvoiceDollar,
} from "react-icons/fa";

const ModuleSelector = ({ currentModule, onModuleChange, currentPage }) => {
  // Define available modules
  const modules = [
    {
      id: "translation",
      name: "Text Translations",
      icon: <FaLanguage className="mr-2" />,
      description: "Edit website text and translations",
    },
    {
      id: "products",
      name: "Products",
      icon: <FaBoxOpen className="mr-2" />,
      description: "Manage homepage product showcase",
      visibleOn: ["home"],
    },
    {
      id: "menu",
      name: "Menu Items",
      icon: <FaUtensils className="mr-2" />,
      description: "Manage menu sections and items",
      visibleOn: ["menuCarta", "menuAperitivo", "wineList"],
    },
    {
      id: "listino",
      name: "Listino Manager",
      icon: <FaFileInvoiceDollar className="mr-2" />,
      description: "Manage products catalog for retailers",
      visibleOn: ["listino", "home"],
    },
    {
      id: "images",
      name: "Image Manager",
      icon: <FaImage className="mr-2" />,
      description: "Upload and manage website images",
    },
  ];

  // Filter modules to only show ones relevant to the current page
  const filteredModules = modules.filter(
    (module) => !module.visibleOn || module.visibleOn.includes(currentPage)
  );

  return (
    <div className="bg-gray-100 p-4 rounded-lg mb-6">
      <h2 className="text-lg font-bold mb-3">Editor Modules</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {filteredModules.map((module) => (
          <button
            key={module.id}
            onClick={() => onModuleChange(module.id)}
            className={`p-3 rounded-lg border transition-colors flex flex-col items-center text-center ${
              currentModule === module.id
                ? "bg-blue-100 border-blue-300 text-blue-800"
                : "bg-white border-gray-200 hover:bg-gray-50"
            }`}
          >
            <div className="text-xl mb-2">{module.icon}</div>
            <div className="font-medium">{module.name}</div>
            <div className="text-xs text-gray-600 mt-1">
              {module.description}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModuleSelector;
